import { Reveal } from "./Reveal";
import { ArrowRight } from "lucide-react";
import { ClaudeMark, ClaudeBadge } from "./ClaudeMark";

const today = [
  "Responder um e-mail mais rápido",
  "Escrever um post de Instagram",
  "Pedir uma ideia de campanha",
  "Resumir um texto longo",
];

const after = [
  "Acompanha seu mercado todo dia e te entrega o que mudou",
  "Responde lead novo no padrão da sua empresa, sem você ler antes",
  "Faz follow-up dos orçamentos que ficaram sem resposta",
  "Monta o relatório semanal do seu comercial e escreve a comunicação no seu tom",
  "Te avisa quando algo importante mexe no seu setor",
  "Sugere onde você está perdendo dinheiro ou tempo",
];

export function PromiseSection() {
  return (
    <section className="relative bg-charcoal py-10 md:py-14">
      <div className="absolute inset-x-0 top-0 gold-divider" />
      <div className="absolute inset-x-0 bottom-0 gold-divider" />

      <div className="container-narrow">
        <div className="mx-auto max-w-3xl text-center">
          <p className="mb-4 text-[11px] uppercase tracking-[0.4em] text-gold">
            A virada do programa
          </p>
          <h2 className="text-balance text-3xl text-ivory md:text-5xl">
            Você sai do uso de IA <em className="not-italic text-gold">para tarefa</em> —
            e entra no uso de IA que <em className="not-italic text-gold">opera por você.</em>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate-muted md:text-lg">
            A diferença entre como você usa IA hoje e o que você leva pra casa
            depois das 4 sessões do SPRINT CODE.
          </p>
        </div>

        <div className="mx-auto mt-10 grid max-w-6xl items-stretch gap-6 md:grid-cols-[1fr_auto_1.2fr] md:gap-4">
          {/* HOJE — Ponto A */}
          <Reveal x={-20} duration={0.6}
            className="rounded-2xl border border-border bg-background/40 p-7 md:p-8"
          >
            <p className="mb-2 text-[10px] uppercase tracking-[0.35em] text-slate-muted">
              Hoje
            </p>
            <h3 className="mb-4 text-xl text-ivory/80 md:text-2xl">
              Você usa IA para tarefa.
            </h3>
            <p className="mb-5 text-sm leading-relaxed text-slate-muted">
              No máximo, hoje você pede pra ela:
            </p>
            <ul className="space-y-2.5">
              {today.map((t) => (
                <li
                  key={t}
                  className="flex items-start gap-3 text-[15px] leading-snug text-slate-muted"
                >
                  <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-slate-muted/60" />
                  <span>{t}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 border-t border-border/60 pt-4 text-xs italic text-slate-muted">
              Útil. Mas é IA fazendo tarefa — não IA trabalhando por você.
            </p>
          </Reveal>

          {/* SETA */}
          <div className="hidden items-center justify-center md:flex">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-gradient-gold shadow-elegant">
              <ArrowRight className="h-6 w-6 text-primary-foreground" />
            </div>
          </div>

          {/* DEPOIS — Ponto B */}
          <Reveal x={20} duration={0.6} delay={0.15}
            className="relative overflow-hidden rounded-2xl border border-gold/40 bg-card p-7 shadow-elegant md:p-9"
          >
            {/* Estrela Claude como ornamento editorial */}
            <ClaudeMark
              className="pointer-events-none absolute -right-8 -top-8 h-44 w-44 text-gold/10"
              title="Claude"
            />

            <div className="relative">
              <ClaudeBadge className="mb-3" />
              <h3 className="mb-4 text-xl text-ivory md:text-2xl">
                Você sai com o Claude Code configurado para a sua necessidade.
              </h3>
              <p className="mb-5 text-sm leading-relaxed text-slate-muted">
                Conforme o que o mapa mostrar, ele pode:
              </p>
              <ul className="space-y-2.5">
                {after.map((a) => (
                  <li
                    key={a}
                    className="flex items-start gap-3 text-[15px] leading-snug text-ivory"
                  >
                    <ClaudeMark className="mt-1 h-3.5 w-3.5 shrink-0 text-gold" />
                    <span>{a}</span>
                  </li>
                ))}
              </ul>
              <p
                className="mt-6 border-t border-gold/20 pt-4 text-base italic text-gold-soft"
                style={{ fontFamily: "var(--font-display)" }}
              >
                Não é IA respondendo perguntas. É IA operando uma área da sua empresa.
              </p>
            </div>
          </Reveal>
        </div>

        <div className="mx-auto mt-10 max-w-3xl text-center">
          <p className="mb-4 text-[11px] uppercase tracking-[0.4em] text-gold">
            Arquitetura própria
          </p>
          <h3 className="text-balance text-2xl text-ivory md:text-4xl">
            Uma arquitetura que é sua, e não de uma IA.
          </h3>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate-muted md:text-lg">
            Tudo o que a gente constrói mora em pastas no seu computador, de acordo com a sua necessidade — nada de modelo genérico. Hoje o Claude é a melhor IA para executar. Se amanhã outra for melhor, você troca e não perde nada.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            {["Claude", "ChatGPT", "Gemini", "Grok"].map((label) => (
              <span key={label} className="rounded-full border border-gold/40 bg-midnight/60 px-3 py-1 text-[10px] uppercase tracking-[0.3em] text-gold-soft">
                {label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
